import { render, staticRenderFns } from "./EventTypeSelector.vue?vue&type=template&id=0b770461&"
import script from "./EventTypeSelector.vue?vue&type=script&lang=js&"
export * from "./EventTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports